import React from "react";

export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16 text-zinc-300" data-testid="terms-page">
      <span className="label-overline">// Legal</span>
      <h1 className="font-display text-5xl tracking-widest leading-none mt-3 mb-10">Terms of Service</h1>

      <p className="text-sm text-zinc-500 mb-8">Last updated: February 2026</p>

      <div className="space-y-6 text-sm leading-relaxed">
        <p>
          Welcome to Train With Lucy. By creating an account or buying any class or subscription, you agree to these terms.
        </p>

        <h2 className="font-display text-2xl tracking-wider text-white pt-4">1. Health disclaimer</h2>
        <p>
          The classes are for general fitness only. They are <span className="text-white">not medical advice</span>. Always consult a qualified healthcare professional before starting any new exercise programme — especially if you are pregnant, recovering from injury, or have any medical condition. You participate at your own risk.
        </p>

        <h2 className="font-display text-2xl tracking-wider text-white pt-4">2. Your account</h2>
        <p>
          You're responsible for keeping your login secure and for everything that happens under your account. Don't share your account credentials.
        </p>

        <h2 className="font-display text-2xl tracking-wider text-white pt-4">3. Purchases & subscriptions</h2>
        <ul className="list-disc list-outside pl-5 space-y-2">
          <li>Single-class purchases give you lifetime access to that class while the Service is operational.</li>
          <li>Monthly subscriptions unlock all classes for as long as the subscription is active.</li>
          <li>Subscriptions auto-renew until cancelled. Cancel anytime from the Subscribe page — access continues until the end of the current billing cycle.</li>
          <li>All prices are in GBP and processed via PayPal.</li>
        </ul>

        <h2 className="font-display text-2xl tracking-wider text-white pt-4">4. Refunds</h2>
        <p>
          Due to the digital nature of the Service, all sales are final. Refunds may be considered case-by-case for technical issues that prevent access — email us within 14 days of purchase.
        </p>

        <h2 className="font-display text-2xl tracking-wider text-white pt-4">5. Content & sharing</h2>
        <p>
          All videos, thumbnails, programmes and branding are owned by Train With Lucy. You get a personal, non-transferable licence to stream them. <span className="text-white">Don't download, screen-record, redistribute, or share content publicly</span>. Doing so may result in account suspension and legal action.
        </p>

        <h2 className="font-display text-2xl tracking-wider text-white pt-4">6. Acceptable use</h2>
        <p>
          Don't use the Service to do anything illegal, harass others, or attempt to break or reverse-engineer the platform.
        </p>

        <h2 className="font-display text-2xl tracking-wider text-white pt-4">7. Liability</h2>
        <p>
          The Service is provided "as is". To the maximum extent permitted by law, Train With Lucy is not liable for any injury, loss, or damage arising from use of the Service or the classes.
        </p>

        <h2 className="font-display text-2xl tracking-wider text-white pt-4">8. Changes</h2>
        <p>
          We may update these terms from time to time. Continued use after changes means you accept the updated terms.
        </p>

        <h2 className="font-display text-2xl tracking-wider text-white pt-4">9. Contact</h2>
        <p>
          Questions? Email <a className="text-[#D4A574] hover:underline" href="mailto:hello@trainwithlucy.app">hello@trainwithlucy.app</a>.
        </p>
      </div>
    </div>
  );
}
